import { render, staticRenderFns } from "./FinanceConfig.vue?vue&type=template&id=0500834f"
import script from "./FinanceConfig.vue?vue&type=script&lang=js"
export * from "./FinanceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports